<form class="form-popup" [formGroup]="formGroup" >
    <div class="dialog-row">
      <div class="dialog-column">
        <ng-container *ngIf="scheduleItemToEdit.scheduleItemId != 0">
          <mat-form-field>
            <mat-label>ID #</mat-label>
            <input matInput
                  class="fullWidth"
                  name="ID #"
                  formControlName="scheduleItemId" />
          </mat-form-field>
        </ng-container>
      </div>

      <div class="dialog-column">
        <ng-container *ngIf="scheduleItemToEdit.scheduleItemId != 0 && permissions.canCreate(permissions.ComponentID.Scheduler) && !cloning">
          <button type="button"
              class="btn btn-default btn-sm"
              title="Clone Schedule Item"
              (click)="cloneSI()">
            <i class="fas fa-clone"></i>&nbsp;Clone
          </button>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="scheduleItemToEdit.scheduleItemId == 0 && cloning">
      <hr />
      <b style="color:red">
        *************************************************** CLONING ***************************************************
      </b>
      <hr />
    </ng-container>

    <!--Display Job Title of the employee being relieved so you can select the correct employee for the job this data is not saved-->
    <ng-container *ngIf="scheduleItemToEdit.reliefForJtId != null">
    <div class="dialog-row">
      <div class="dialog-column">
      </div>
      <div class="dialog-column">
        <mat-form-field>
          <mat-label>Requestor</mat-label>
            <mat-select formControlName="reliefForJtId"
                        class="fullWidth" name="Requestor" >
                    <mat-option *ngFor="let t of jobTitleValues | async" [value]="t.jobTitleId">
                        {{ t.jobTitle }}
                    </mat-option>
            </mat-select>
        </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="dialog-row">
      <div class="dialog-column">
        <mat-form-field>
          <mat-label>Type</mat-label>
          <mat-select formControlName="scheduleItemTypeId" name="Type" (selectionChange)="typeValueChange($event)" >
            <mat-option *ngFor="let t of scheduleItemTypeValues | async" [value]="t.scheduleItemTypeId">
                {{ t.scheduleItemType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="dialog-column">
        <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId == siType.relief">
          <aims-lookup title="Relief For" name="Relief For"
                       id="reliefForId"
                       [values]="filteredReliefFor | async"
                       [idPropertyName]="'employeeId'"
                       [displayPropertyName]="'fullName'"
                       formControlName="reliefForId"
                       [gridText]="'Select an Employee for Relief'"
                       [columnsInGrid]="employeeLookupColumns"
                       (valueChange)="reliefForId.next($event)"
                       >
          </aims-lookup>
        </ng-container>

        <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId == siType.overhire">
          <aims-lookup title="For Title"
                       id="forTitle" name="For Title"
                       [values]="jobTitleValues | async"
                       [idPropertyName]="'jobTitleId'"
                       [displayPropertyName]="'jobTitle'"
                       formControlName="overhireJtId"
                       [gridText]="'Select a Job Title'"
                       [columnsInGrid]="jobTitleLookupColumns"
                       (valueChange)="overhireJtId.next($event)"
                       >
          </aims-lookup>
        </ng-container>
      </div>
    </div>

    <div class="dialog-row">
      <div class="dialog-column">
        <mat-form-field>
          <mat-label>From</mat-label>
            <input matInput [ngxMatDatetimePicker]="scheduleItemStart"
                            placeholder="Choose a date and time"
                            formControlName="scheduleItemStart"
                            name="From"
                            >
            <mat-datepicker-toggle matSuffix [for]="scheduleItemStart"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #scheduleItemStart [showSeconds]="false">
                <!-- Custom icon or text of Apply icon -->
                <ng-template>
                <!-- <mat-icon>star</mat-icon> -->
                <span>OK</span>
                </ng-template>
            </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>

      <div class="dialog-column">
        <mat-form-field>
          <mat-label>To</mat-label>
            <input matInput [ngxMatDatetimePicker]="scheduleItemEnd"
                            placeholder="Choose a date and time"
                            formControlName="scheduleItemEnd"
                            name="To" >
            <mat-datepicker-toggle matSuffix [for]="scheduleItemEnd"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #scheduleItemEnd [showSeconds]="false">
                <!-- Custom icon or text of Apply icon -->
                <ng-template>
                <!-- <mat-icon>star</mat-icon> -->
                <span>OK</span>
                </ng-template>
            </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>

    <div class="dialog-row">
      <div class="dialog-column">
        <mat-form-field>
          <mat-label>Site</mat-label>
            <mat-select formControlName="siteId" name="Site" (selectionChange)="siteValueChange($event)" >
                <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                  {{ s.siteName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
      </div>

      <div class="dialog-column">
        <ng-container *ngIf="isEmpSiType()">
          <aims-lookup style="padding-top: 0%; margin-top: 0%;"
                       title="Name" name="Name"
                       id="empName"
                       [values]="filteredEmps | async"
                       [idPropertyName]="'employeeId'"
                       [displayPropertyName]="'fullName'"
                       formControlName="employeeId"
                       [gridText]="'Select an Employee:'"
                       [columnsInGrid]="employeeLookupColumns"
                       (valueChangeObj)="nameValueChange($event)" >
          </aims-lookup>
        </ng-container>
        <ng-container *ngIf="!isEmpSiType()">
          <aims-lookup title="Resource Name"
                       id="resName" name="resName"
                       [values]="filteredRes | async"
                       [idPropertyName]="'resourceId'"
                       [displayPropertyName]="'fullName'"
                       formControlName="resourceId"
                       [gridText]="'Select a Resource'"
                       [columnsInGrid]="resourceLookupColumns"
                       (valueChangeObj)="nameValueChange($event)" >
          </aims-lookup>
        </ng-container>
      </div>
    </div>

  <mat-tab-group>
  <mat-tab label="Schedule Item" aria-label="Schedule Item">
    <div class="checkbox-row" >
      <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId != siType.notAvailable && scheduleItemToEdit.scheduleItemTypeId != siType.vacation">
        <div >
          <mat-checkbox
            title="Requires Site Arrival Notice"
            name="SAN"
            formControlName="siteArrivalNoticeRequired"
            tabindex="-1" >
            SAN
          </mat-checkbox>
        </div>
      </ng-container>

      <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId != siType.flight && scheduleItemToEdit.scheduleItemTypeId != siType.notAvailable && scheduleItemToEdit.scheduleItemTypeId != siType.vacation">
        <div>
          <mat-checkbox
            title="Requires Travel Arrangements"
            name="Travel"
            formControlName="travelArrangeReq"
            (change)="travelArrangeReqChange($event)"
            tabindex="-1" >
            Travel
          </mat-checkbox>

        <ng-container *ngIf="scheduleItemToEdit.travelArrangeReq && !((trLegData | async)?.length > 0)">
          <a class="btn btn-default" (click)="addTravelRequest()" style="margin-left: 20px;" *ngIf="!addTR">
            New Travel Request
          </a>
          <div *ngIf="addTR">
            Travel Request will be added upon Save
          </div>
        </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId == siType.flight">
      <div class="dialog-row">
        <div class="dialog-column">
          <aims-lookup title="Carrier" name="Carrier"
                       id="resCarrier"
                       [values]="carrierValues | async"
                       [idPropertyName]="'resourceId'"
                       [displayPropertyName]="'organizationName'"
                       formControlName="carrierId"
                       [gridText]="'Select a Carrier'"
                       [columnsInGrid]="carrierLookupColumns"
                       (valueChangeObj)="carrierChange($event)" >
          </aims-lookup>
        </div>
        <div class="dialog-column">
          <mat-form-field>
            <mat-label>Flt/Tail #</mat-label>
            <input matInput
                 type="text"
                 name="Flt/Tail #"
                 title="Flight Number"
                 formControlName="flightNumber" >
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId != siType.flight && scheduleItemToEdit.siteArrivalNoticeRequired">
      <div class="dialog-row">
        <div class="dialog-column">
          <aims-lookup title="Arrival Carrier" name="Arrival Carrier"
                       id="arrivalCarrier"
                       [values]="carriersArriving"
                       [idPropertyName]="'id'"
                       [displayPropertyName]="'organization'"
                       formControlName="arrivalCarrierSchItemId"
                       [gridText]="'Select a Arrival Carrier'"
                       [columnsInGrid]="arrivalOrDepartureCarrierLookupColumns" >
          </aims-lookup>
        </div>
        <div class="dialog-column">
          <aims-lookup title="Departure Carrier" name="Departure Carrier"
                       id="departureCarrier"
                       [values]="carriersDeparting"
                       [idPropertyName]="'id'"
                       [displayPropertyName]="'organization'"
                       formControlName="departureCarrierSchItemId"
                       [gridText]="'Select a Departure Carrier'"
                       [columnsInGrid]="arrivalOrDepartureCarrierLookupColumns" >
          </aims-lookup>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId != siType.flight && scheduleItemToEdit.scheduleItemTypeId != siType.notAvailable && scheduleItemToEdit.scheduleItemTypeId != siType.vacation">
      <ng-container *ngIf="(trLegData | async)?.length > 0 && !cloning && scheduleItemToEdit.scheduleItemId != 0">
        <h4>Travel Legs:</h4>

          <table id="t01">
            <tr>
              <th>
                <b><u>TR #</u></b>
              </th>
              <th>
                <b><u>FROM</u></b>
              </th>
              <th>
                <b><u>TO</u></b>
              </th>
              <th>
                <b><u>TRAVEL ON</u></b>
              </th>
            </tr>
            <tr *ngFor="let tl of trLegData | async">
              <td>
                <a [routerLink]="'/scheduling/travelRequest/' + tl.travelRequestId" target="_blank">{{tl.travelRequestId}}</a>
              </td>
              <td>
                {{tl.travelFromId | getText:'siteId':'siteName':siteValues | async}}
              </td>
              <td>
                {{tl.travelToId | getText:'siteId':'siteName':siteValues | async}}
              </td>
              <td>
                <ng-container *ngIf="tl.travelOn == null">
                  OPEN
                </ng-container>
                <ng-container *ngIf="tl.travelOn != null">
                  {{tl.travelOn | date:'MM-dd-yyyy'}}
                </ng-container>
              </td>
            </tr>
          </table>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId != siType.flight && scheduleItemToEdit.scheduleItemTypeId != siType.notAvailable && scheduleItemToEdit.scheduleItemTypeId != siType.vacation">
      <div class="checkbox-row" style="margin-top: 10px;">
           <mat-checkbox
            title="Gov Billed"
            name="Gov Billed"
            formControlName="govBilled"
            tabindex="-1" >
            Gov Billed
          </mat-checkbox>
          <mat-checkbox
            title="Company Billed"
            name="Company Billed"
            formControlName="companyBilled"
            tabindex="-1" >
            Company Billed
          </mat-checkbox>
      </div>

      <div class="dialog-row">
        <div class="dialog-column">
            <mat-form-field style="padding-left: 10px;">
              <mat-label>Purpose</mat-label>
              <input matInput
                    type="text"
                    name="Purpose"
                    title="Purpose of Visit"
                    formControlName="purpose"
                />
            </mat-form-field>
        </div>
        <div class="dialog-column">
        </div>
      </div>

      <div class="checkbox-row">
          <mat-checkbox
            title="Meals"
            name="Meals"
            formControlName="meals"
            tabindex="-1" >
            Meals
          </mat-checkbox>
          <mat-checkbox
            title="Billeting"
            name="Billeting"
            formControlName="billeting"
            tabindex="-1" >
            Billeting
          </mat-checkbox>
      </div>
    </ng-container>

    <ng-container *ngIf="scheduleItemToEdit.scheduleItemTypeId != siType.flight && scheduleItemToEdit.scheduleItemTypeId != siType.medical && scheduleItemToEdit.scheduleItemTypeId != siType.notAvailable && scheduleItemToEdit.scheduleItemTypeId != siType.vacation">
      <!-- <div class="dialog-row" style="margin-top: 10px;"> -->
      <div class="dialog-row" >
        <div class="dialog-column">
          <mat-form-field>
            <mat-label>Clearance</mat-label>
            <mat-select formControlName="clearanceId" name="Clearance" >
              <mat-option *ngFor="let c of clearanceValues | async" [value]="c.clearanceId">
                {{ c.clearanceName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="dialog-column">
          <ng-container *ngIf="!isNewSch(scheduleItemToEdit)">
            <mat-form-field>
              <mat-label>O&A #</mat-label>
                <mat-select formControlName="oanumber" name="O&A #" >
                  <mat-option *ngFor="let o of oaNumberValues | async" [value]="o.oanumber">
                      {{ o.oaTask }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="isNewSch(scheduleItemToEdit)">
            <mat-form-field>
              <mat-label>O&A #</mat-label>
                <mat-select formControlName="oanumber" name="O&A #" >
                  <mat-option *ngFor="let o of activeOaNumberValues | async" [value]="o.oanumber">
                    {{ o.oaTask }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
      </div>

      <div class="dialog-row" >
       <div class="dialog-column">
       </div>
       <div class="dialog-column">
          <mat-form-field>
            <mat-label>DSW COPA #</mat-label>
              <mat-select formControlName="copanumber" name="DSW COPA #" >
                <mat-option *ngFor="let o of copas | async" [value]="o.copaId">
                    {{ o.copaNumber }} - {{ o.copaDescription }}
                </mat-option>
              </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="checkbox-row" style="height: 100px;">
        <div>
           <mat-checkbox
            title="Classified"
            name="Classified"
            formControlName="classifiedAccess"
            tabindex="-1" >Classified
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            name="Restricted"
            formControlName="restrictedAccess"
            tabindex="-1" >Restricted
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            name="COMSEC"
            formControlName="comsecaccess"
            tabindex="-1" >COMSEC
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            name="TER"
            formControlName="teraccess"
            tabindex="-1">TER
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            title="Escort Only"
            name="Escort"
            formControlName="escortOnly"
            tabindex="-1">Escort
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            title="Restricted Area Photography"
            name="Photography"
            formControlName="restrictedAreaPhotography"
            tabindex="-1">Photography
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
                 title="Radar downtime requested?"
                 name="Radar DT"
                 formControlName="radarDowntime"
                 tabindex="-1" >Radar DT
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
                 title="Requires transporation to top camp?"
                 name="Trans TC"
                 formControlName="transToTopCamp"
                 tabindex="-1">Trans TC
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
                 title="Requesting to take firearm(s)?"
                 name="Firearm(s)?"
                 formControlName="firearmRequest"
                 (change)="firearmRequestChange($event)"
                 tabindex="-1">Firearm(s)?
          </mat-checkbox>
        </div>
      </div>

      <ng-container *ngIf="firearmRequested">
          <aims-common-table
              [dataSource]="scheduleItemToEdit.schFirearms"
              [header]="firearmsTableHeader"
              [permissions]="firearmsTablePermissions"
              id="firearms-table"
              [stickyHeader]="true"
              [pageSize]="5"
              (rowUpdated)="handleFirearmRowUpdate($event)"
              (rowDeleted)="handleFirearmRowDelete($event)"
              (rowAdded)="handleFirearmRowAdd($event)"
              [addRowInitialObject]="defaultFirearm"
          >

                  <!-- *ngIf="element.firearmId != 0"  -->
            <aims-common-table-dynamic-row id="approve">
              <ng-template viewMode let-element >
                <aims-common-button-mini
                  title="Approve"
                  [disabled]="element.approvedOn != null"
                  [attr.aria-label]="Approve"
                  (click)="approveFirearm(element)"
                  >
                  <mat-icon color="primary">thumb_up</mat-icon>
                </aims-common-button-mini>
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <aims-common-button-mini
                  [attr.aria-label]="Approve"
                  title="Approve"
                  [disabled]="element.approvedOn != null"
                  (click)="approveFirearm(element)"
                >
                  <mat-icon color="primary">thumb_up</mat-icon>
                </aims-common-button-mini>
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="disapprove">
              <ng-template viewMode let-element >
                <aims-common-button-mini
                  title="Disapprove"
                  [disabled]="element.disapprovedOn != null"
                  [attr.aria-label]="disapprove"
                  (click)="disapproveFirearm(element)"
                  >
                  <mat-icon color="primary">thumb_down</mat-icon>
                </aims-common-button-mini>
              </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <aims-common-button-mini
                  title="Disapprove"
                  [disabled]="element.disapprovedOn != null"
                  [attr.aria-label]="disapprove"
                  (click)="disapproveFirearm(element)"
                >
                  <mat-icon color="primary">thumb_down</mat-icon>
                </aims-common-button-mini>
              </ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>
      </ng-container>
    </ng-container>
  </mat-tab>

      <mat-tab aria-label="Inventory" label="Inventory" *ngIf="inventoryAllowed()" >
            <ng-template matTabContent >
        <ng-container *ngIf="isNewSch(scheduleItemToEdit)" >
          <h3 class="warningmessage">Schedule Item must be saved before adding Inventory</h3>
        </ng-container>

        <ng-container *ngIf="!isNewSch(scheduleItemToEdit)" >

                  <aims-common-table
                    id="pulled-parts-table"
                    [dataSource]="attachedItems"
                    [header]="partsTableHeader"
                    [permissions]="partsTablePermissions"
                    label="Parts From Inventory"
                    pageSize="10"
                    (rowUpdated)="saveHandler($event)"
                    (rowCancelled)="cancelHandler($event)"
                    [stickyHeader]="true">

                    <aims-common-table-dynamic-row id="quantity">
                      <ng-template viewMode let-element >
                        {{ getAttachedItemPulledQuantity(element.attachedItemId) }}
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <aims-common-table-dynamic-row id="partCost">
                      <ng-template viewMode let-element >
                        {{ getAttachedItemPulledCost(element.attachedItemId) | currency: "USD":"symbol":"1.2-4" }}
                      </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- sub-table -->
                    <ng-template aimsCommonTableExpandedRow let-element>
                      <mat-card>
                      <aims-common-table
                        label=""
                        [id]="'pulled-detail-table-' + element.position"
                        class="sub-table"
                        [dataSource]="element.invAttachedItemPulled"
                        [header]="partsSubTableHeader"
                        [permissions]="{ filter: false, create: false, update: false, 'delete': false }"
                      >
                        <aims-common-table-dynamic-row id="unitCost">
                          <ng-template viewMode let-element >
                            {{ element.inventoryItemReceived.costPerUnit | currency: "USD":"symbol":"1.2-4" }}
                          </ng-template>
                        </aims-common-table-dynamic-row>

                      </aims-common-table>
                      </mat-card>
                    </ng-template>
                  </aims-common-table>

                  <div style="float: right; padding: 20px 10px;">
                    <mat-card>
                    Total Parts Cost:
                        {{ getTotalAttachedItemsPulledCost() | currency: "USD":"symbol":"1.2-4" }}
                    </mat-card>
                  </div>

              <div style="margin-top: 30px;">
                <h5>Add Inventory</h5>
              </div>
              <app-add-inventory-item (AddInventoryItemEvent)="addItemToScheduleItem($event)"></app-add-inventory-item>
              <hr/>
              </ng-container>
            </ng-template>

      </mat-tab>

      <mat-tab aria-label="Assets" label="Assets"  *ngIf="inventoryAllowed()" >
        <ng-template matTabContent >
        <ng-container *ngIf="isNewSch(scheduleItemToEdit)" >
          <h3 class="warningmessage">Schedule Item must be saved before adding Assets</h3>
        </ng-container>

        <ng-container *ngIf="!isNewSch(scheduleItemToEdit)" >
                  <aims-common-table
                    id="attached-assets-table"
                    [dataSource]="attachedAssets"
                    [header]="assetsTableHeader"
                    [permissions]="assetsTablePermissions"
                    label="Assets"
                    pageSize="5"
                    (rowDeleted)="detachAsset($event)"
                    [stickyHeader]="true">
                  </aims-common-table>

                  <aims-lookup
                        class="fullWidth"
                        title="Asset to Attach"
                        name="Asset to Attach"
                        [gridText]="'Select an Asset'"
                        [values]="equipmentList | async"
                        [displayPropertyName]="'equipmentIdOld'"
                        [idPropertyName]="'equipmentId'"
                        formControlName="equipmentIdToAdd"
                        [columnsInGrid]="equipmentLookupColumns"
                        (valueChangeObj)="assetChange($event)" >
                  </aims-lookup>

             <hr/>
          </ng-container>

        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <div style="margin-top: 10px;">
        <mat-form-field>
          <mat-label>Notes</mat-label>
          <textarea matInput
              cdkTextareaAutosize
              class="fullWidth"
              name="Notes"
              formControlName="notes" >
          </textarea>
        </mat-form-field>
    </div>

    <div class="dialog-row">
      <div class="dialog-column">
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select formControlName="scheduleItemStatusId" name="Status"  (selectionChange)="statusValueChange($event)" >
                    <mat-option *ngFor="let s of scheduleItemStatusValues | async" [value]="s.scheduleItemStatusId">
                        {{ s.scheduleItemStatus }}
                    </mat-option>
            </mat-select>
        </mat-form-field>
      </div>

      <div class="dialog-column">
        <mat-form-field>
          <mat-label>Modified By</mat-label>
          <mat-select formControlName="modifiedById" name="Modified By" >
              <mat-option *ngFor="let e of employeeValues | async" [value]="e.employeeId">
                {{ e.fullName }}
              </mat-option>
            </mat-select>
        </mat-form-field>
      </div>
    </div>

</form>

<ng-template #showSpinner>
  <aims-spinner showSpinner="true" spinnerText="Loading..."></aims-spinner>
</ng-template>
